import { COMPANY_INFO } from "../constants/company";
import { countryTransfertService } from "../services/administration/countryTransfertService";
import { countryNameFr, currencyLabel, formatFeesLabel, formatNumberFr, groupRatesBySender } from "./dailyRates";

/** Date du jour : "04 Novembre 2026". */
const todayLabel = () => {
  const d = new Date();
  const month = d.toLocaleDateString("fr-FR", { month: "long" });
  return `${String(d.getDate()).padStart(2, "0")} ${month.charAt(0).toUpperCase()}${month.slice(1)} ${d.getFullYear()}`;
};

/** Charge les taux depuis l'API et les met en forme pour le modèle "daily-rates". */
const loadDailyRates = async () => {
  const rates = await countryTransfertService.getCountryTransferts(500, 0);
  return groupRatesBySender(rates || []).map((group) => ({
    senderName: countryNameFr(group.sender),
    items: group.items.map((r) => {
      const toCurrency = currencyLabel(r.country_destination?.devise);
      // Frais : "0 fcfa" tant que l'API ne renvoie pas de champ "fees"
      const fees = (r as unknown as Record<string, unknown>).fees;
      return {
        senderName: countryNameFr(r.country_sender),
        destinationName: countryNameFr(r.country_destination),
        rateLabel: `${formatNumberFr(r.rate)} ${toCurrency}`.trim(),
        feesLabel: formatFeesLabel(fees, r.country_sender?.devise),
      };
    }),
  }));
};

/**
 * Données communes à tous les modèles d'email (année, infos entreprise),
 * plus les taux chargés depuis l'API pour le modèle "Taux du jour".
 */
export const enrichTemplateDataAsync = async (
  templateId: string,
  data: Record<string, unknown>
): Promise<Record<string, unknown>> => {
  const enriched: Record<string, unknown> = {
    ...data,
    currentYear: new Date().getFullYear().toString(),
    company: COMPANY_INFO,
  };

  if (templateId === "daily-rates") {
    // L'aperçu fournit ses propres données fictives ; à l'envoi, on charge les vrais taux.
    if (!Array.isArray(enriched.rateGroups)) enriched.rateGroups = await loadDailyRates();
    if (!enriched.dateLabel) enriched.dateLabel = todayLabel();
  }

  return enriched;
};
